// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Editor Theme */
* {
  box-sizing: border-box !important;
}
:root {
  --box-background-color: #fafafa;
  --editor-heading-font-color: #252103;

  --editor-toolbar-icon-size: 12px;
  --editor-toolbar-icon-size: 16px;
  --editor-toolbar-icon-size-lg: 18px;
  --shortcut-width-lg: 360px;
  --shortcut-height-lg: 370px;
}

.editor-title .file-title-card .file-title-container {
  margin: 0 !important;
}

.editor-title .file-title-card .file-heading {
  margin: 0px !important;
  overflow-wrap: break-word;
  font-size: calc(var(--cms-editor-font-size-heading1)) !important;
}

/* Editor Box */
.remirror-editor {
  font-family: var(--cms-font-family);
  font-size: 16px; /* Base font size */
  line-height: 1.75; /* Improved line height for readability */
  letter-spacing: 0.004em; /* Slight letter spacing */
  color: #333; /* Text color */
  background-color: var(--cms-color-bg-container);
  border-radius: 0px !important;
}

/* Editor wrapper adjustments */
.remirror-editor-wrapper {
  /* max-height: 100%; */
  padding: 0 !important;
  overflow-y: auto;
  background-color: var(--cms-color-bg-container);
}

.edit-editor-title {
  width: 100% !important;
}

@media (max-width: 767px) {
  .edit-editor-title {
    margin-top: 0.5rem;
  }
  .edit-editor-title .ant-card-body {
    margin-top: 5rem;
  }
  .comment-span {
    display: none;
  }
}

/* @media (max-width: 480px) {
  .toolbar {
    position: fixed !important;
    z-index: 500 !important;
    padding: 10px 5px;
    width: 100%;
    box-shadow: 0 2px 0 0 #f1f2f4;
    top: 0px;
    height: auto;
    gap: 0.5rem;
    display: flex !important;
    flex-wrap: wrap !important;
  }
  .toolbar-wrapper {
    position: relative !important;

  }
} */

.remirror-resizable-view {
  display: inline-block !important;
  margin-bottom: 1rem;
  width: 550px;
}

div:has(> .remirror-table.remirror-table-with-controllers) {
  overflow-x: auto;
  padding: 1px;
  margin-bottom: 24px !important;
}

.remirror-table-tbody-with-controllers > tr:nth-of-type(n + 2) th,
.remirror-table-tbody-with-controllers > tr:nth-of-type(1) th:nth-of-type(1),
.remirror-table-tbody-with-controllers > tr:nth-of-type(1) th:nth-of-type(n + 2) {
  z-index: 2 !important;
}

.remirror-table.remirror-table-with-controllers td {
  padding: var(--ant-padding-xxs) var(--ant-padding) !important;
}

div:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar {
  margin-top: 10px;
  width: 12px;
  height: 12px;
  cursor: default !important;
}

div:has(> .remirror-table.remirror-table-with-controllers) th p {
  margin-bottom: 0 !important;
  padding: 12px 0 !important;
}

div:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-track {
  background: #f0f0f0; /* Track color */
  border-radius: 0px;
  cursor: default !important;
}

div:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-thumb {
  background-color: var(--ant-color-bg-text-active); /* Thumb color */
  border-radius: 0px;
  box-shadow: none;
  outline: none;
  border: none;
  cursor: default !important;
}

div:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-thumb:hover {
  background-color: var(--ant-color-bg-text-active);
  box-shadow: none;
  outline: none;
  border: none;
}

.ProseMirror.remirror-editor.remirror-a11y-dark {
  padding: 0 calc(var(--cms-padding-sm) * 1px);
  height: 100% !important;
  cursor: text !important;
  overflow: hidden !important;
}
.remirror-table-colgroup col {
  min-width: 70px;
}

.emoji {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
}

.emoji .emoji-wrapper {
  font-size: 24px;
}
.emoji .emoji-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: var(--sp-color-text-default);
}

.emoji .emoji-code {
  font-size: 13px;
  color: var(--sp-color-text-muted);
}

.divider {
  background: var(--editor-heading-font-color);
}

.find-and-replace-wrapper {
  position: fixed;
  top: 102px;
  right: 12px;
  background: var(--box-background-color);
  border: 1px solid rgba(250, 250, 250, 0.1);
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
}

.remirror-theme.edit .find-and-replace-wrapper {
  top: 154px;
}

/* find option related settings */

.replace-option-wrapper {
  margin-top: 8px;
}

.find-option-wrapper,
.replace-option-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.find-option-input-wrapper .find-option-input input,
.replace-option-input-wrapper .replace-option-input input {
  max-width: 250px !important;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  border-radius: 0px;
  line-height: 1.5;
  padding: 2px 4px;
  transition:
    box-shadow 100ms ease-in,
    border 100ms ease-in,
    background-color 100ms ease-in;
  border: 2px solid #dee1e2;
  color: var(--editor-title-font-color);
  background: var(--box-background-color);
  display: block;
  min-height: unset !important;
}

.find-option-input input:hover,
.find-option-input input:focus,
.replace-option-input input:hover,
.replace-option-input input:focus {
  border-color: var(--primary-color) !important;
}

.find-option-input .ant-input-group-addon .add-on-text {
  font-size: 13px;
}

/* find action button */
.find-option-actions,
.replace-option-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}

.find-option-action,
.replace-option-action {
  padding: 0 !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 0px !important;
  border-width: 2px;
}

.find-option-action .ant-btn-icon svg,
.replace-option-action .ant-btn-icon svg {
  width: 14px !important;
  height: 14px !important;
}

.find-option-action.case-sensitive-btn.active {
  border-color: var(--primary-color);
  box-shadow: inset 0 0 0 1px var(--primary-color);
}

.find-option-action.case-sensitive-btn svg,
.replace-option-action.case-sensitive-btn svg {
  width: 20px !important;
  height: 20px !important;
}

.find-and-replace-wrapper .description-wrapper {
  padding-left: 4px;
}

.find-and-replace-wrapper .description-wrapper span {
  font-size: 14px;
}

.table-submenu-item .ant-menu-submenu-title,
.table-menu-item {
  height: 30px !important;
  padding: 4px 8px !important;
  margin: 0 4px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 8px;
  border-radius: 0px !important;
  width: 100% !important;
}

ul.table-menu {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.table-submenu-item .ant-menu-submenu-title > span:nth-child(1),
.table-menu-item > span:nth-child(1) {
  width: 18px !important;
  height: 18px !important;
}

.table-submenu-item .ant-menu-submenu-title > .ant-menu-title-content,
.table-menu-item .ant-menu-title-content {
  margin: 0 !important;
}
.table-cell-option-btn {
  width: 20px !important;
  height: 20px !important;
  background-color: var(--toolbar-button-hover) !important;
}
.table-cell-option-btn svg {
  width: 12px;
  height: 12px;
}

.table-bottom-popover-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.25rem;
  border: 1px solid var(--toolbar-button-hover);
  background-color: var(--sidemenu-background-color);
  box-sizing: border-box;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
  z-index: 5;
  transform: translate(-50%, -15%);
  border-radius: 0.25rem;
}

.table-bottom-popover-button {
  border: none;
}

.remirror-table-tbody-with-controllers tr:nth-child(2) th:nth-child(n + 2) {
  background-color: gray;
}

.remirror-table-tbody-with-controllers tr:nth-child(2) th > p {
  font-weight: bold !important;
}

.remirror-table-colgroup > col:first-of-type {
  min-width: 13px;
  overflow: visible;
}

.date-node {
  background-color: var(--toolbar-button-hover);
  padding: 4px;
  border-radius: 4px;
  font-size: 14px;
  color: var(--date-node-text-color);
}

.comment-card .ProseMirror.remirror-editor.remirror-a11y-dark {
  min-height: auto !important;
  padding: 0 !important;
}
.comment-editor .ProseMirror.remirror-editor.remirror-a11y-dark {
  min-height: 150px !important;
  padding: 0rem 1.5rem !important;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

.hyperlink {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  gap: 8px;
  text-decoration: none;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  max-width: 100%;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border-color: #0052cc;
  }

  & a {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #0052cc;
    text-decoration: none;
  }

  & img {
    width: 16px;
    height: 16px;
  }
}

.hyperlink-hover-card {
  position: absolute;
  display: none;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background-color: var(--box-background-color);
  border-radius: 4px;
  width: 0;
  max-height: 0px;
  overflow: hidden;
  opacity: 0;
  z-index: 99;
  border: 1px solid var(--border-color);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);

  transition:
    opacity 300ms ease-out,
    max-height 300ms ease-out;

  &.hover-card-show {
    transition:
      opacity 300ms ease-out,
      max-height 300ms ease-out;

    &.hover-card-show {
      display: flex;
      opacity: 1;
      min-width: 320px;
      max-width: 320px;
      max-height: 320px;
    }

    & .hover-card-loading {
      background-color: #f2f2f2;
      animation: pulse 2s ease-in-out infinite;
      height: 64px;
      width: 100%;
      border-radius: 4px;
    }

    & .hover-card-text-link {
      display: flex;
      flex-direction: column;
      gap: 4px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      & .hover-card-title {
        padding: 0px;
        margin: 0px;
        color: #0052cc;
        font-weight: 600;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-clamp: 2;
      }
      & .hover-card-description {
        color: gray;
        font-size: 14px;
        font-weight: 400;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        line-clamp: 3;
      }
    }

    & .hover-card-image {
      width: 100%;
      height: 100%;
      background-color: #f2f2f2;
      overflow: hidden;
    }

    & .hover-card-image img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: contain;
    }
  }
}

/* editor base css */
.remirror-editor h1,
.remirror-editor h2,
.remirror-editor h3,
.remirror-editor h4,
.remirror-editor h5,
.remirror-editor h6,
.remirror-editor p {
  margin: 0 !important;
  padding: var(--cms-editor-padding-xxs) 0px !important;
  color: var(--cms-color-text) !important;
}

.remirror-editor h1 {
  font-size: var(--cms-editor-font-size-heading1) !important;
  line-height: var(--cms-editor-line-height1) !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom1) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
}

.remirror-editor h2 {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
  font-family: var(--cms-font-family, 'SF Pro Text') !important;
  font-size: var(--cms-editor-font-size-heading2, 30px) !important;
  font-style: normal !important;
  font-weight: var(--cms-editor-heading-font-weight, 700) !important;
  line-height: var(--cms-editor-line-height2, 38px) !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom2) !important;
}

.remirror-editor h3 {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
  font-size: var(--cms-editor-font-size-heading3) !important;
  line-height: var(--cms-editor-line-height3) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  font-style: normal !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom3) !important;
}

.remirror-editor h4 {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
  font-size: var(--cms-editor-font-size-heading4) !important;
  line-height: var(--cms-editor-line-height4) !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom4) !important;
  font-style: normal !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
}

.remirror-editor h5 {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
  font-size: var(--cms-editor-font-size-heading5) !important;
  line-height: var(--cms-editor-line-height5) !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom5) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  font-style: normal;
}

.remirror-editor h6 {
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
  font-size: var(--cms-editor-font-size-heading6) !important;
  line-height: var(--cms-editor-line-height6) !important;
  margin-bottom: var(--cms-editor-heading-margin-bottom6) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  font-style: normal;
}

.remirror-editor p {
  font-size: var(--cms-font-size-lg) !important;
  line-height: var(--cms-editor-line-height) !important;
  margin-bottom: calc(var(--cms-margin) * 1px) !important;
  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;
}

.remirror-editor li > p {
  margin-bottom: 0px !important;
}

.remirror-editor li {
  margin-bottom: calc(var(--cms-editor-padding-xxxs) * 1px) !important;
}

.remirror-editor li > ul,
.remirror-editor li > ol {
  margin-bottom: calc(var(--cms-margin-xxs) * 1px) !important;
}

.remirror-editor ul,
.remirror-editor ol {
  margin: 0;
  margin-bottom: var(--cms-editor-list-margin-top) !important;
  margin-bottom: var(--cms-editor-list-margin-bottom) !important;
}

.remirror-editor p > code {
  font-family: var(--cms-font-family-code) !important;
  padding: calc(var(--cms-editor-padding-xxxs) * 1px) calc(var(--cms-padding-xxs) * 1px) !important;
  background-color: var(--cms-color-fill-tertiary);
  border-radius: calc(var(--cms-editor-border-radius) * 1px) !important;
}

.remirror-editor ul {
  list-style-type: disc;
}

.remirror-editor a {
  color: var(--cms-color-link) !important;
}

.remirror-editor hr {
  margin-top: calc(var(--cms-margin-xxs) * 9px) !important;
  margin-bottom: calc(var(--cms-margin-xxs) * 9px) !important;
  border: none;
  color: var(--cms-color-border) !important;
  background-color: var(--cms-color-border) !important;
  height: 1px !important;
  border-radius: 1px;
}

.remirror-editor ul + h2,
.remirror-editor ol + h2,
.remirror-editor pre + h2,
.remirror-editor p + h2 {
  margin-top: calc(var(--cms-margin) * 1px + 12px) !important;
}

.remirror-editor ul + h3,
.remirror-editor ol + h3,
.remirror-editor pre + h3,
.remirror-editor p + h3 {
  margin-top: calc(var(--cms-margin) * 1px + 8px) !important;
}

.remirror-editor ul + h4,
.remirror-editor ol + h4,
.remirror-editor pre + h4,
.remirror-editor p + h4 {
  margin-top: calc(var(--cms-margin) * 1px + 4px) !important;
}

.remirror-resizable-view {
  margin-top: calc(var(--cms-margin-sm) * 1px) !important;
  margin-bottom: calc(var(--cms-margin-sm) * 1px) !important;
}

.remirror-editor h1 + .remirror-resizable-view,
.remirror-editor h2 + .remirror-resizable-view,
.remirror-editor h3 + .remirror-resizable-view,
.remirror-editor h4 + .remirror-resizable-view,
.remirror-editor h5 + .remirror-resizable-view,
.remirror-editor h6 + .remirror-resizable-view {
  margin-top: 0 !important;
}

.ProseMirror.remirror-editor.remirror-a11y-dark {
  border: none !important;
  outline: none !important;
}

.remirror-theme {
  max-width: var(--remirror-editor-width) !important;
  width: 100% !important;
  height: 100% !important;
  position: relative !important;
  height: 100%;
  background-color: var(--cms-color-bg-base); /* Soft background */
  border: none;
}

.remirror-theme .editor-title {
  width: 100%;
}

.cover-image__dropdown {
  max-width: 540px;
  min-width: 540px;
  max-height: 400px;
  overflow-y: auto !important;
  border-radius: var(--ant-border-radius-lg) !important;
}

.cover-image__dropdown .dropdown-group__header {
  display: flex;
  height: var(--ant-control-height, 32px);
  /* margin-bottom: var(--ant-margin-xs); */
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
}

.cover-image__dropdown img {
  display: block;
  object-fit: cover;
  border-radius: var(--cms-border-radius-sm, 4px);
  width: 100%;
  height: 64px;
  object-position: center 60%;
}

.editor__root-dropdown {
  padding: 0 !important;
  border: 1px solid var(--ant-color-border);
  box-shadow: var(--ant-box-shadow-tertiary);
  border-radius: calc(var(--cms-border-radius) * 1px);
  overflow: hidden;
}

.editor__root-dropdown .dropdown__header {
  padding: 0 var(--ant-padding-xxs);
  padding-bottom: var(--ant-padding-xxs);
  border-bottom: 1px solid var(--ant-color-border);
  margin-bottom: var(--ant-margin-xxs);
}
.editor__root-dropdown .dropdown__body {
  padding: 0 var(--ant-padding-xxs);
}

.editor__root-dropdown .dropdown__header .header-secondary-action {
  font-size: 13px !important;
  color: var(--ant-color-text-secondary) !important;
  line-height: 0.5;
}

.cover-image__dropdown .dropdown__body {
  width: 452px;
}

.cover-image__dropdown .dropdown__body .dropdown-group__body {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: var(--ant-margin-xs);
}

.cms__color__picker .ant-popover-inner {
  padding: calc(var(--cms-padding-xs) * 1px) !important;
  min-width: 275px !important;
}

.cms__color__picker .ant-collapse-header,
.cms__color__picker .ant-collapse-header .ant-collapse-expand-icon {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
}

.cms__color__picker .ant-collapse-header .ant-color-picker-presets-label {
  color: var(--cms-color-text-secondary) !important;
  text-transform: capitalize;
  font-family: var(--cms-font-family, 'SF Pro Text');
  font-size: 13px;
  font-weight: 500;
}

.cms__color__picker .ant-collapse-content {
  padding: calc(var(--cms-padding-xs) * 1px);
  padding-top: calc(var(--cms-padding-xxs) * 1px);
  padding-bottom: calc(var(--cms-padding-xxs) * 1px);
}

.cms__color__picker .ant-collapse-content .ant-collapse-content-box {
  padding: calc(var(--cms-padding-xxs) * 1px) !important;
}

.cms-shortcut.mention-shortcut-menu {
  width: calc(var(--shortcut-width) * 1px) !important;
  max-height: calc(var(--shortcut-height) * 1px) !important;
}

.cms-shortcut.slash-shortcut-menu {
  width: calc(var(--shortcut-width) * 1px) !important;
  height: calc(var(--shortcut-height) * 1px) !important;
}

.cms-shortcut.slash-shortcut-menu.collapse {
  display: none !important;
}

.slash-shortcut-menu .icon-wrapper {
  display: flex;
  padding: calc(var(--cms-padding-xs) * 1px);
  align-items: center;
  gap: calc(var(--cms-padding-xs) * 1px);
  border-radius: calc(var(--cms-padding-xxs) * 1px);
  border: 1px solid var(--cms-color-border, #d9d9d9);
}

.shortcut-menu-wrapper {
  box-sizing: border-box !important;
  width: calc(var(--shortcut-menu-width, 400px) * 1px) !important;
  max-height: calc(var(--shortcut-menu-height, 400px) * 1px) !important;
  width: 100%;
  background-color: var(--ant-color-bg-elevated);
  border: 1px solid var(--ant-color-border);
  border-radius: var(--ant-border-radius);
  box-shadow: var(--ant-box-shadow-secondary) !important;
  overflow-x: hidden;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: var(--ant-padding-xxs) !important;
  padding: var(--ant-padding-xs) var(--ant-padding-sm) !important;
}

.slash-shortcut-menu .shortcut-menu-wrapper {
  max-width: calc(var(--shortcut-menu-width, 360px) * 1px) !important;
  max-height: calc(var(--shortcut-menu-height, 370px) * 1px) !important;
  gap: var(--ant-padding-xs) !important;
}

.slash-shortcut-menu .shortcut-menu-wrapper .ant-dropdown-menu-vertical {
  max-height: unset !important;
  overflow-y: unset !important;
}

.shortcut-menu-item .ant-dropdown-menu-title-content {
  width: 100% !important;
}

.shortcut-menu-wrapper .shortcut-menu {
  padding: 0 !important;
  box-shadow: none !important;
}

.shortcut-menu .group__label {
  background-color: transparent !important;
  padding: var(--ant-padding-xxs, 4px) 0px !important;
}

.shortcut-menu .group__label span {
  display: block;
  color: var(--ant-color-text-tertiary) !important;
  font-size: var(--ant-font-size) !important;
  font-family: var(--ant-font-weight-strong);
  font-weight: 500;
  text-transform: capitalize;
}

.shortcut-menu .shortcut-menu-item {
  display: block !important;
  width: 100% !important;
  font-weight: 500 !important;
  transition: background-color 200ms ease-in-out;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  color: var(--cms-color-text) !important;
}

.shortcut-menu .shortcut-menu-item .menu-item-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: calc(var(--cms-padding-sm) * 1px);
}

.shortcut-menu .shortcut-menu-item svg {
  color: var(--cms-color-text-label) !important;
  width: 24px !important;
  height: 24px !important;
}

.shortcut-menu .shortcut-menu-item .menu-item-inner .text {
  color: inherit;
}

.shortcut-menu .shortcut-menu-item:hover {
  background-color: var(--cms-color-fill-secondary) !important;
}

.document-editor .remirror-editor p:empty,
.document-editor .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child),
.document-editor .remirror-editor p:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {
  position: relative;
}

.document-editor .remirror-editor p:empty::after,
.document-editor .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child)::after {
  content: '';
}

.document-editor .edit .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: var(--cms-color-text-placeholder);
  font-size: calc(var(--cms-font-size-lg) * 1px);
  font-family: var(--cms-font-family);
  content: "Write, Press '/' for commands...";
}

.document-editor .remirror-editor h1:empty,
.document-editor .remirror-editor h1:has(br.ProseMirror-trailingBreak:only-child),
.document-editor .remirror-editor h1:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {
  position: relative;
}

.document-editor .remirror-editor h1:empty::after,
.document-editor .remirror-editor h1:has(br.ProseMirror-trailingBreak:only-child)::after {
  content: '';
}

.document-editor
  .edit
  .remirror-editor
  h1:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: var(--cms-color-text-placeholder);
  font-size: var(--cms-editor-font-size-heading1) !important;
  line-height: var(--cms-editor-line-height1) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  content: 'Heading 1';
}

.remirror-editor h2:empty,
.remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child),
.remirror-editor h2:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {
  position: relative;
}

.remirror-editor h2:empty::after,
.remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child)::after {
  content: '';
}

.edit .remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: var(--cms-color-text-placeholder);
  font-size: var(--cms-editor-font-size-heading2) !important;
  line-height: var(--cms-editor-line-height2) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  content: 'Heading 2';
}

.remirror-editor h3:empty,
.remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child),
.remirror-editor h3:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {
  position: relative;
}

.remirror-editor h3:empty::after,
.remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child)::after {
  content: '';
}

.edit .remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: var(--cms-color-text-placeholder);
  font-size: var(--cms-editor-font-size-heading3) !important;
  line-height: var(--cms-editor-line-height3) !important;
  font-weight: var(--cms-editor-heading-font-weight) !important;
  content: 'Heading 3';
}

.emoji-shortcut-layout {
  background-color: var(--cms-color-bg-elevated) !important;
  width: calc(var(--shortcut-width) * 1px) !important;
  max-height: calc(var(--shortcut-height) * 1px) !important;
  box-shadow: var(--cms-box-shadow-secondary) !important;
  border-radius: calc(var(--cms-border-radius) * 1px) !important;
  padding: calc(var(--cms-padding-xs) * 1px) !important;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box !important;
  border: 1px solid var(--ant-color-border);
}

.emoji-shortcut-layout .emoji-shortcut-spacing {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  overflow-y: auto;
  height: 100%;
  max-height: calc(100% - var(--emoji-search-input-height-container));
  overflow-x: hidden;
}

.emoji-shortcut-spacing .emoji-container {
  padding: calc(var(--cms-padding-xxs) * 1px);
  border-radius: calc(var(--cms-border-radius-sm) * 1px);
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  transition: background-color 200ms;
  position: relative;
  min-width: 36px;
  max-width: 36px;
  min-height: 36px;
  max-height: 36px;
  cursor: pointer;
}

.emoji-shortcut-spacing .emoji-container.selected {
  background-color: var(--cms-control-item-bg-active) !important;
}

.inserted-date {
  background-color: var(--toolbar-button-hover);
  padding: 4px;
  border-radius: 4px;
  font-size: 14px;
  color: var(--date-node-text-color);
  cursor: pointer;
}
.ant-picker-input {
  display: flex !important; /* Ensure input is visible */
}
.ant-picker-input > input {
  min-width: 82px !important;
}

/* Editor selected node styles */
.remirror-editor .ProseMirror-selectednode {
  background-color: #cce9ff;
}

table.remirror-table.remirror-table-with-controllers {
  margin: 0px 0px calc(var(--cms-padding) * 1px) 0px !important;
}

.remirror-editor table td > p {
  margin-bottom: 0px !important;
}

.document-editor .ProseMirror.remirror-editor.remirror-a11y-dark [data-thread-id] {
  background: rgba(255, 203, 0, 0.12);
  border-bottom: 2px solid rgba(255, 203, 0, 0.35);
  transition:
    background 0.2s ease,
    border 0.2s ease;
}

.document-editor .remirror-editor .callout .callout-icon {
  --icon-primary-color: #4688e4;
  --icon-warning-color: #fbc828;
  --icon-danger-color: #f15b50;
  --icon-success-color: #b3dfae;
  max-width: 24px !important;
  min-width: 24px !important;
  /* display: flex !important; */
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
}

.remirror-editor div.callout {
  margin-bottom: calc(var(--cms-padding) * 1px) !important;
}

.remirror-editor div[data-callout-type='danger'] {
  background: #feecf0 !important;
  border-left-color: #f14668 !important;
}

.document-editor .remirror-editor .callout p {
  padding: 0 !important;
  margin: 0 !important;
}

.document-editor .remirror-theme.edit .ProseMirror.remirror-editor.remirror-a11y-dark {
  padding-bottom: 12rem !important;
}
`, "",{"version":3,"sources":["webpack://./../editor/src/styles/global.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,iCAAiC;AACnC;AACA;EACE,+BAA+B;EAC/B,oCAAoC;;EAEpC,gCAAgC;EAChC,gCAAgC;EAChC,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA,eAAe;AACf;EACE,mCAAmC;EACnC,eAAe,EAAE,mBAAmB;EACpC,iBAAiB,EAAE,yCAAyC;EAC5D,uBAAuB,EAAE,0BAA0B;EACnD,WAAW,EAAE,eAAe;EAC5B,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD,EAAE,gBAAgB;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,0CAA0C;EAC1C,YAAY;EACZ,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;;AAEjC;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB;;;kCAGgC;EAChC,yBAAyB;EACzB,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;;;EAIE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,QAAQ;EACR,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,kDAAkD;EAClD,sBAAsB;EACtB,8CAA8C;EAC9C,UAAU;EACV,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;;EAEf;IACE,qBAAqB;EACvB;;EAEA;IACE,OAAO;IACP,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,0CAA0C;;EAE1C;;6BAE2B;;EAE3B;IACE;;+BAE2B;;IAE3B;MACE,aAAa;MACb,UAAU;MACV,gBAAgB;MAChB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,yBAAyB;MACzB,wCAAwC;MACxC,YAAY;MACZ,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,qBAAqB;;MAErB;QACE,0BAA0B;MAC5B;;MAEA;QACE,YAAY;QACZ,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,oBAAoB;QACpB,4BAA4B;QAC5B,qBAAqB;QACrB,aAAa;MACf;MACA;QACE,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,oBAAoB;QACpB,4BAA4B;QAC5B,qBAAqB;QACrB,aAAa;MACf;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,mBAAmB;IACrB;EACF;AACF;;AAEA,oBAAoB;AACpB;;;;;;;EAOE,oBAAoB;EACpB,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;EACE,0DAA0D;EAC1D,sDAAsD;EACtD,kEAAkE;EAClE,6DAA6D;AAC/D;;AAEA;EACE,4DAA4D;EAC5D,6DAA6D;EAC7D,gEAAgE;EAChE,6BAA6B;EAC7B,kEAAkE;EAClE,4DAA4D;EAC5D,kEAAkE;AACpE;;AAEA;EACE,4DAA4D;EAC5D,0DAA0D;EAC1D,sDAAsD;EACtD,6DAA6D;EAC7D,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,4DAA4D;EAC5D,0DAA0D;EAC1D,sDAAsD;EACtD,kEAAkE;EAClE,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,4DAA4D;EAC5D,0DAA0D;EAC1D,sDAAsD;EACtD,kEAAkE;EAClE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,0DAA0D;EAC1D,sDAAsD;EACtD,kEAAkE;EAClE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,qDAAqD;EACrD,uDAAuD;EACvD,4DAA4D;AAC9D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;;EAEE,SAAS;EACT,2DAA2D;EAC3D,8DAA8D;AAChE;;AAEA;EACE,mDAAmD;EACnD,iGAAiG;EACjG,gDAAgD;EAChD,qEAAqE;AACvE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wDAAwD;EACxD,2DAA2D;EAC3D,YAAY;EACZ,yCAAyC;EACzC,oDAAoD;EACpD,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;EAIE,2DAA2D;AAC7D;;AAEA;;;;EAIE,0DAA0D;AAC5D;;AAEA;;;;EAIE,0DAA0D;AAC5D;;AAEA;EACE,uDAAuD;EACvD,0DAA0D;AAC5D;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,0CAA0C,EAAE,oBAAoB;EAChE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,yCAAyC;EACzC,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,0CAA0C;EAC1C,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,gDAAgD;EAChD,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,0BAA0B;EAC1B,kDAAkD;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;EACnD,yDAAyD;AAC3D;;AAEA;EACE,mDAAmD;EACnD,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,sCAAsC;EACtC,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,+DAA+D;EAC/D,qEAAqE;EACrE,WAAW;EACX,8CAA8C;EAC9C,yCAAyC;EACzC,uCAAuC;EACvC,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,sCAAsC;EACtC,+DAA+D;AACjE;;AAEA;EACE,mEAAmE;EACnE,qEAAqE;EACrE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,8CAA8C;EAC9C,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,wCAAwC;EACxC,8CAA8C;EAC9C,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,wCAAwC;EACxC,0DAA0D;EAC1D,sDAAsD;EACtD,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,wCAAwC;EACxC,0DAA0D;EAC1D,sDAAsD;EACtD,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,wCAAwC;EACxC,0DAA0D;EAC1D,sDAAsD;EACtD,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,yDAAyD;EACzD,mDAAmD;EACnD,yDAAyD;EACzD,sDAAsD;EACtD,8DAA8D;EAC9D,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,sDAAsD;EACtD,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,wBAAwB,EAAE,4BAA4B;AACxD;AACA;EACE,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,gDAAgD;EAChD;;oBAEkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* Global Editor Theme */\n* {\n  box-sizing: border-box !important;\n}\n:root {\n  --box-background-color: #fafafa;\n  --editor-heading-font-color: #252103;\n\n  --editor-toolbar-icon-size: 12px;\n  --editor-toolbar-icon-size: 16px;\n  --editor-toolbar-icon-size-lg: 18px;\n  --shortcut-width-lg: 360px;\n  --shortcut-height-lg: 370px;\n}\n\n.editor-title .file-title-card .file-title-container {\n  margin: 0 !important;\n}\n\n.editor-title .file-title-card .file-heading {\n  margin: 0px !important;\n  overflow-wrap: break-word;\n  font-size: calc(var(--cms-editor-font-size-heading1)) !important;\n}\n\n/* Editor Box */\n.remirror-editor {\n  font-family: var(--cms-font-family);\n  font-size: 16px; /* Base font size */\n  line-height: 1.75; /* Improved line height for readability */\n  letter-spacing: 0.004em; /* Slight letter spacing */\n  color: #333; /* Text color */\n  background-color: var(--cms-color-bg-container);\n  border-radius: 0px !important;\n}\n\n/* Editor wrapper adjustments */\n.remirror-editor-wrapper {\n  /* max-height: 100%; */\n  padding: 0 !important;\n  overflow-y: auto;\n  background-color: var(--cms-color-bg-container);\n}\n\n.edit-editor-title {\n  width: 100% !important;\n}\n\n@media (max-width: 767px) {\n  .edit-editor-title {\n    margin-top: 0.5rem;\n  }\n  .edit-editor-title .ant-card-body {\n    margin-top: 5rem;\n  }\n  .comment-span {\n    display: none;\n  }\n}\n\n/* @media (max-width: 480px) {\n  .toolbar {\n    position: fixed !important;\n    z-index: 500 !important;\n    padding: 10px 5px;\n    width: 100%;\n    box-shadow: 0 2px 0 0 #f1f2f4;\n    top: 0px;\n    height: auto;\n    gap: 0.5rem;\n    display: flex !important;\n    flex-wrap: wrap !important;\n  }\n  .toolbar-wrapper {\n    position: relative !important;\n\n  }\n} */\n\n.remirror-resizable-view {\n  display: inline-block !important;\n  margin-bottom: 1rem;\n  width: 550px;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers) {\n  overflow-x: auto;\n  padding: 1px;\n  margin-bottom: 24px !important;\n}\n\n.remirror-table-tbody-with-controllers > tr:nth-of-type(n + 2) th,\n.remirror-table-tbody-with-controllers > tr:nth-of-type(1) th:nth-of-type(1),\n.remirror-table-tbody-with-controllers > tr:nth-of-type(1) th:nth-of-type(n + 2) {\n  z-index: 2 !important;\n}\n\n.remirror-table.remirror-table-with-controllers td {\n  padding: var(--ant-padding-xxs) var(--ant-padding) !important;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar {\n  margin-top: 10px;\n  width: 12px;\n  height: 12px;\n  cursor: default !important;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers) th p {\n  margin-bottom: 0 !important;\n  padding: 12px 0 !important;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-track {\n  background: #f0f0f0; /* Track color */\n  border-radius: 0px;\n  cursor: default !important;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-thumb {\n  background-color: var(--ant-color-bg-text-active); /* Thumb color */\n  border-radius: 0px;\n  box-shadow: none;\n  outline: none;\n  border: none;\n  cursor: default !important;\n}\n\ndiv:has(> .remirror-table.remirror-table-with-controllers)::-webkit-scrollbar-thumb:hover {\n  background-color: var(--ant-color-bg-text-active);\n  box-shadow: none;\n  outline: none;\n  border: none;\n}\n\n.ProseMirror.remirror-editor.remirror-a11y-dark {\n  padding: 0 calc(var(--cms-padding-sm) * 1px);\n  height: 100% !important;\n  cursor: text !important;\n  overflow: hidden !important;\n}\n.remirror-table-colgroup col {\n  min-width: 70px;\n}\n\n.emoji {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n}\n\n.emoji .emoji-wrapper {\n  font-size: 24px;\n}\n.emoji .emoji-name {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--sp-color-text-default);\n}\n\n.emoji .emoji-code {\n  font-size: 13px;\n  color: var(--sp-color-text-muted);\n}\n\n.divider {\n  background: var(--editor-heading-font-color);\n}\n\n.find-and-replace-wrapper {\n  position: fixed;\n  top: 102px;\n  right: 12px;\n  background: var(--box-background-color);\n  border: 1px solid rgba(250, 250, 250, 0.1);\n  padding: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n}\n\n.remirror-theme.edit .find-and-replace-wrapper {\n  top: 154px;\n}\n\n/* find option related settings */\n\n.replace-option-wrapper {\n  margin-top: 8px;\n}\n\n.find-option-wrapper,\n.replace-option-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.find-option-input-wrapper .find-option-input input,\n.replace-option-input-wrapper .replace-option-input input {\n  max-width: 250px !important;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  border-radius: 0px;\n  line-height: 1.5;\n  padding: 2px 4px;\n  transition:\n    box-shadow 100ms ease-in,\n    border 100ms ease-in,\n    background-color 100ms ease-in;\n  border: 2px solid #dee1e2;\n  color: var(--editor-title-font-color);\n  background: var(--box-background-color);\n  display: block;\n  min-height: unset !important;\n}\n\n.find-option-input input:hover,\n.find-option-input input:focus,\n.replace-option-input input:hover,\n.replace-option-input input:focus {\n  border-color: var(--primary-color) !important;\n}\n\n.find-option-input .ant-input-group-addon .add-on-text {\n  font-size: 13px;\n}\n\n/* find action button */\n.find-option-actions,\n.replace-option-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.find-option-action,\n.replace-option-action {\n  padding: 0 !important;\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 0px !important;\n  border-width: 2px;\n}\n\n.find-option-action .ant-btn-icon svg,\n.replace-option-action .ant-btn-icon svg {\n  width: 14px !important;\n  height: 14px !important;\n}\n\n.find-option-action.case-sensitive-btn.active {\n  border-color: var(--primary-color);\n  box-shadow: inset 0 0 0 1px var(--primary-color);\n}\n\n.find-option-action.case-sensitive-btn svg,\n.replace-option-action.case-sensitive-btn svg {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.find-and-replace-wrapper .description-wrapper {\n  padding-left: 4px;\n}\n\n.find-and-replace-wrapper .description-wrapper span {\n  font-size: 14px;\n}\n\n.table-submenu-item .ant-menu-submenu-title,\n.table-menu-item {\n  height: 30px !important;\n  padding: 4px 8px !important;\n  margin: 0 4px !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  gap: 8px;\n  border-radius: 0px !important;\n  width: 100% !important;\n}\n\nul.table-menu {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.table-submenu-item .ant-menu-submenu-title > span:nth-child(1),\n.table-menu-item > span:nth-child(1) {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.table-submenu-item .ant-menu-submenu-title > .ant-menu-title-content,\n.table-menu-item .ant-menu-title-content {\n  margin: 0 !important;\n}\n.table-cell-option-btn {\n  width: 20px !important;\n  height: 20px !important;\n  background-color: var(--toolbar-button-hover) !important;\n}\n.table-cell-option-btn svg {\n  width: 12px;\n  height: 12px;\n}\n\n.table-bottom-popover-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  padding: 0.25rem;\n  border: 1px solid var(--toolbar-button-hover);\n  background-color: var(--sidemenu-background-color);\n  box-sizing: border-box;\n  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);\n  z-index: 5;\n  transform: translate(-50%, -15%);\n  border-radius: 0.25rem;\n}\n\n.table-bottom-popover-button {\n  border: none;\n}\n\n.remirror-table-tbody-with-controllers tr:nth-child(2) th:nth-child(n + 2) {\n  background-color: gray;\n}\n\n.remirror-table-tbody-with-controllers tr:nth-child(2) th > p {\n  font-weight: bold !important;\n}\n\n.remirror-table-colgroup > col:first-of-type {\n  min-width: 13px;\n  overflow: visible;\n}\n\n.date-node {\n  background-color: var(--toolbar-button-hover);\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 14px;\n  color: var(--date-node-text-color);\n}\n\n.comment-card .ProseMirror.remirror-editor.remirror-a11y-dark {\n  min-height: auto !important;\n  padding: 0 !important;\n}\n.comment-editor .ProseMirror.remirror-editor.remirror-a11y-dark {\n  min-height: 150px !important;\n  padding: 0rem 1.5rem !important;\n}\n\n@keyframes pulse {\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.hyperlink {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  gap: 8px;\n  text-decoration: none;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  max-width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n\n  &:hover {\n    border-color: #0052cc;\n  }\n\n  & a {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #0052cc;\n    text-decoration: none;\n  }\n\n  & img {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.hyperlink-hover-card {\n  position: absolute;\n  display: none;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px;\n  background-color: var(--box-background-color);\n  border-radius: 4px;\n  width: 0;\n  max-height: 0px;\n  overflow: hidden;\n  opacity: 0;\n  z-index: 99;\n  border: 1px solid var(--border-color);\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);\n\n  transition:\n    opacity 300ms ease-out,\n    max-height 300ms ease-out;\n\n  &.hover-card-show {\n    transition:\n      opacity 300ms ease-out,\n      max-height 300ms ease-out;\n\n    &.hover-card-show {\n      display: flex;\n      opacity: 1;\n      min-width: 320px;\n      max-width: 320px;\n      max-height: 320px;\n    }\n\n    & .hover-card-loading {\n      background-color: #f2f2f2;\n      animation: pulse 2s ease-in-out infinite;\n      height: 64px;\n      width: 100%;\n      border-radius: 4px;\n    }\n\n    & .hover-card-text-link {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n\n      & .hover-card-title {\n        padding: 0px;\n        margin: 0px;\n        color: #0052cc;\n        font-weight: 600;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n        line-clamp: 2;\n      }\n      & .hover-card-description {\n        color: gray;\n        font-size: 14px;\n        font-weight: 400;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 3;\n        line-clamp: 3;\n      }\n    }\n\n    & .hover-card-image {\n      width: 100%;\n      height: 100%;\n      background-color: #f2f2f2;\n      overflow: hidden;\n    }\n\n    & .hover-card-image img {\n      width: 100%;\n      height: 100%;\n      border-radius: 4px;\n      object-fit: contain;\n    }\n  }\n}\n\n/* editor base css */\n.remirror-editor h1,\n.remirror-editor h2,\n.remirror-editor h3,\n.remirror-editor h4,\n.remirror-editor h5,\n.remirror-editor h6,\n.remirror-editor p {\n  margin: 0 !important;\n  padding: var(--cms-editor-padding-xxs) 0px !important;\n  color: var(--cms-color-text) !important;\n}\n\n.remirror-editor h1 {\n  font-size: var(--cms-editor-font-size-heading1) !important;\n  line-height: var(--cms-editor-line-height1) !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom1) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n}\n\n.remirror-editor h2 {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n  font-family: var(--cms-font-family, 'SF Pro Text') !important;\n  font-size: var(--cms-editor-font-size-heading2, 30px) !important;\n  font-style: normal !important;\n  font-weight: var(--cms-editor-heading-font-weight, 700) !important;\n  line-height: var(--cms-editor-line-height2, 38px) !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom2) !important;\n}\n\n.remirror-editor h3 {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n  font-size: var(--cms-editor-font-size-heading3) !important;\n  line-height: var(--cms-editor-line-height3) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  font-style: normal !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom3) !important;\n}\n\n.remirror-editor h4 {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n  font-size: var(--cms-editor-font-size-heading4) !important;\n  line-height: var(--cms-editor-line-height4) !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom4) !important;\n  font-style: normal !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n}\n\n.remirror-editor h5 {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n  font-size: var(--cms-editor-font-size-heading5) !important;\n  line-height: var(--cms-editor-line-height5) !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom5) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  font-style: normal;\n}\n\n.remirror-editor h6 {\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n  font-size: var(--cms-editor-font-size-heading6) !important;\n  line-height: var(--cms-editor-line-height6) !important;\n  margin-bottom: var(--cms-editor-heading-margin-bottom6) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  font-style: normal;\n}\n\n.remirror-editor p {\n  font-size: var(--cms-font-size-lg) !important;\n  line-height: var(--cms-editor-line-height) !important;\n  margin-bottom: calc(var(--cms-margin) * 1px) !important;\n  color: var(--cms-color-text, rgba(0, 0, 0, 0.88)) !important;\n}\n\n.remirror-editor li > p {\n  margin-bottom: 0px !important;\n}\n\n.remirror-editor li {\n  margin-bottom: calc(var(--cms-editor-padding-xxxs) * 1px) !important;\n}\n\n.remirror-editor li > ul,\n.remirror-editor li > ol {\n  margin-bottom: calc(var(--cms-margin-xxs) * 1px) !important;\n}\n\n.remirror-editor ul,\n.remirror-editor ol {\n  margin: 0;\n  margin-bottom: var(--cms-editor-list-margin-top) !important;\n  margin-bottom: var(--cms-editor-list-margin-bottom) !important;\n}\n\n.remirror-editor p > code {\n  font-family: var(--cms-font-family-code) !important;\n  padding: calc(var(--cms-editor-padding-xxxs) * 1px) calc(var(--cms-padding-xxs) * 1px) !important;\n  background-color: var(--cms-color-fill-tertiary);\n  border-radius: calc(var(--cms-editor-border-radius) * 1px) !important;\n}\n\n.remirror-editor ul {\n  list-style-type: disc;\n}\n\n.remirror-editor a {\n  color: var(--cms-color-link) !important;\n}\n\n.remirror-editor hr {\n  margin-top: calc(var(--cms-margin-xxs) * 9px) !important;\n  margin-bottom: calc(var(--cms-margin-xxs) * 9px) !important;\n  border: none;\n  color: var(--cms-color-border) !important;\n  background-color: var(--cms-color-border) !important;\n  height: 1px !important;\n  border-radius: 1px;\n}\n\n.remirror-editor ul + h2,\n.remirror-editor ol + h2,\n.remirror-editor pre + h2,\n.remirror-editor p + h2 {\n  margin-top: calc(var(--cms-margin) * 1px + 12px) !important;\n}\n\n.remirror-editor ul + h3,\n.remirror-editor ol + h3,\n.remirror-editor pre + h3,\n.remirror-editor p + h3 {\n  margin-top: calc(var(--cms-margin) * 1px + 8px) !important;\n}\n\n.remirror-editor ul + h4,\n.remirror-editor ol + h4,\n.remirror-editor pre + h4,\n.remirror-editor p + h4 {\n  margin-top: calc(var(--cms-margin) * 1px + 4px) !important;\n}\n\n.remirror-resizable-view {\n  margin-top: calc(var(--cms-margin-sm) * 1px) !important;\n  margin-bottom: calc(var(--cms-margin-sm) * 1px) !important;\n}\n\n.remirror-editor h1 + .remirror-resizable-view,\n.remirror-editor h2 + .remirror-resizable-view,\n.remirror-editor h3 + .remirror-resizable-view,\n.remirror-editor h4 + .remirror-resizable-view,\n.remirror-editor h5 + .remirror-resizable-view,\n.remirror-editor h6 + .remirror-resizable-view {\n  margin-top: 0 !important;\n}\n\n.ProseMirror.remirror-editor.remirror-a11y-dark {\n  border: none !important;\n  outline: none !important;\n}\n\n.remirror-theme {\n  max-width: var(--remirror-editor-width) !important;\n  width: 100% !important;\n  height: 100% !important;\n  position: relative !important;\n  height: 100%;\n  background-color: var(--cms-color-bg-base); /* Soft background */\n  border: none;\n}\n\n.remirror-theme .editor-title {\n  width: 100%;\n}\n\n.cover-image__dropdown {\n  max-width: 540px;\n  min-width: 540px;\n  max-height: 400px;\n  overflow-y: auto !important;\n  border-radius: var(--ant-border-radius-lg) !important;\n}\n\n.cover-image__dropdown .dropdown-group__header {\n  display: flex;\n  height: var(--ant-control-height, 32px);\n  /* margin-bottom: var(--ant-margin-xs); */\n  align-items: center;\n  gap: 8px;\n  flex: 1 0 0;\n}\n\n.cover-image__dropdown img {\n  display: block;\n  object-fit: cover;\n  border-radius: var(--cms-border-radius-sm, 4px);\n  width: 100%;\n  height: 64px;\n  object-position: center 60%;\n}\n\n.editor__root-dropdown {\n  padding: 0 !important;\n  border: 1px solid var(--ant-color-border);\n  box-shadow: var(--ant-box-shadow-tertiary);\n  border-radius: calc(var(--cms-border-radius) * 1px);\n  overflow: hidden;\n}\n\n.editor__root-dropdown .dropdown__header {\n  padding: 0 var(--ant-padding-xxs);\n  padding-bottom: var(--ant-padding-xxs);\n  border-bottom: 1px solid var(--ant-color-border);\n  margin-bottom: var(--ant-margin-xxs);\n}\n.editor__root-dropdown .dropdown__body {\n  padding: 0 var(--ant-padding-xxs);\n}\n\n.editor__root-dropdown .dropdown__header .header-secondary-action {\n  font-size: 13px !important;\n  color: var(--ant-color-text-secondary) !important;\n  line-height: 0.5;\n}\n\n.cover-image__dropdown .dropdown__body {\n  width: 452px;\n}\n\n.cover-image__dropdown .dropdown__body .dropdown-group__body {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  margin-bottom: var(--ant-margin-xs);\n}\n\n.cms__color__picker .ant-popover-inner {\n  padding: calc(var(--cms-padding-xs) * 1px) !important;\n  min-width: 275px !important;\n}\n\n.cms__color__picker .ant-collapse-header,\n.cms__color__picker .ant-collapse-header .ant-collapse-expand-icon {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n}\n\n.cms__color__picker .ant-collapse-header .ant-color-picker-presets-label {\n  color: var(--cms-color-text-secondary) !important;\n  text-transform: capitalize;\n  font-family: var(--cms-font-family, 'SF Pro Text');\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.cms__color__picker .ant-collapse-content {\n  padding: calc(var(--cms-padding-xs) * 1px);\n  padding-top: calc(var(--cms-padding-xxs) * 1px);\n  padding-bottom: calc(var(--cms-padding-xxs) * 1px);\n}\n\n.cms__color__picker .ant-collapse-content .ant-collapse-content-box {\n  padding: calc(var(--cms-padding-xxs) * 1px) !important;\n}\n\n.cms-shortcut.mention-shortcut-menu {\n  width: calc(var(--shortcut-width) * 1px) !important;\n  max-height: calc(var(--shortcut-height) * 1px) !important;\n}\n\n.cms-shortcut.slash-shortcut-menu {\n  width: calc(var(--shortcut-width) * 1px) !important;\n  height: calc(var(--shortcut-height) * 1px) !important;\n}\n\n.cms-shortcut.slash-shortcut-menu.collapse {\n  display: none !important;\n}\n\n.slash-shortcut-menu .icon-wrapper {\n  display: flex;\n  padding: calc(var(--cms-padding-xs) * 1px);\n  align-items: center;\n  gap: calc(var(--cms-padding-xs) * 1px);\n  border-radius: calc(var(--cms-padding-xxs) * 1px);\n  border: 1px solid var(--cms-color-border, #d9d9d9);\n}\n\n.shortcut-menu-wrapper {\n  box-sizing: border-box !important;\n  width: calc(var(--shortcut-menu-width, 400px) * 1px) !important;\n  max-height: calc(var(--shortcut-menu-height, 400px) * 1px) !important;\n  width: 100%;\n  background-color: var(--ant-color-bg-elevated);\n  border: 1px solid var(--ant-color-border);\n  border-radius: var(--ant-border-radius);\n  box-shadow: var(--ant-box-shadow-secondary) !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  gap: var(--ant-padding-xxs) !important;\n  padding: var(--ant-padding-xs) var(--ant-padding-sm) !important;\n}\n\n.slash-shortcut-menu .shortcut-menu-wrapper {\n  max-width: calc(var(--shortcut-menu-width, 360px) * 1px) !important;\n  max-height: calc(var(--shortcut-menu-height, 370px) * 1px) !important;\n  gap: var(--ant-padding-xs) !important;\n}\n\n.slash-shortcut-menu .shortcut-menu-wrapper .ant-dropdown-menu-vertical {\n  max-height: unset !important;\n  overflow-y: unset !important;\n}\n\n.shortcut-menu-item .ant-dropdown-menu-title-content {\n  width: 100% !important;\n}\n\n.shortcut-menu-wrapper .shortcut-menu {\n  padding: 0 !important;\n  box-shadow: none !important;\n}\n\n.shortcut-menu .group__label {\n  background-color: transparent !important;\n  padding: var(--ant-padding-xxs, 4px) 0px !important;\n}\n\n.shortcut-menu .group__label span {\n  display: block;\n  color: var(--ant-color-text-tertiary) !important;\n  font-size: var(--ant-font-size) !important;\n  font-family: var(--ant-font-weight-strong);\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.shortcut-menu .shortcut-menu-item {\n  display: block !important;\n  width: 100% !important;\n  font-weight: 500 !important;\n  transition: background-color 200ms ease-in-out;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  color: var(--cms-color-text) !important;\n}\n\n.shortcut-menu .shortcut-menu-item .menu-item-inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: calc(var(--cms-padding-sm) * 1px);\n}\n\n.shortcut-menu .shortcut-menu-item svg {\n  color: var(--cms-color-text-label) !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.shortcut-menu .shortcut-menu-item .menu-item-inner .text {\n  color: inherit;\n}\n\n.shortcut-menu .shortcut-menu-item:hover {\n  background-color: var(--cms-color-fill-secondary) !important;\n}\n\n.document-editor .remirror-editor p:empty,\n.document-editor .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child),\n.document-editor .remirror-editor p:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {\n  position: relative;\n}\n\n.document-editor .remirror-editor p:empty::after,\n.document-editor .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child)::after {\n  content: '';\n}\n\n.document-editor .edit .remirror-editor p:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-placeholder);\n  font-size: calc(var(--cms-font-size-lg) * 1px);\n  font-family: var(--cms-font-family);\n  content: \"Write, Press '/' for commands...\";\n}\n\n.document-editor .remirror-editor h1:empty,\n.document-editor .remirror-editor h1:has(br.ProseMirror-trailingBreak:only-child),\n.document-editor .remirror-editor h1:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {\n  position: relative;\n}\n\n.document-editor .remirror-editor h1:empty::after,\n.document-editor .remirror-editor h1:has(br.ProseMirror-trailingBreak:only-child)::after {\n  content: '';\n}\n\n.document-editor\n  .edit\n  .remirror-editor\n  h1:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-placeholder);\n  font-size: var(--cms-editor-font-size-heading1) !important;\n  line-height: var(--cms-editor-line-height1) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  content: 'Heading 1';\n}\n\n.remirror-editor h2:empty,\n.remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child),\n.remirror-editor h2:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {\n  position: relative;\n}\n\n.remirror-editor h2:empty::after,\n.remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child)::after {\n  content: '';\n}\n\n.edit .remirror-editor h2:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-placeholder);\n  font-size: var(--cms-editor-font-size-heading2) !important;\n  line-height: var(--cms-editor-line-height2) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  content: 'Heading 2';\n}\n\n.remirror-editor h3:empty,\n.remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child),\n.remirror-editor h3:is(:empty, :has(> .ProseMirror-trailingBreak:only-child)):focus {\n  position: relative;\n}\n\n.remirror-editor h3:empty::after,\n.remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child)::after {\n  content: '';\n}\n\n.edit .remirror-editor h3:has(br.ProseMirror-trailingBreak:only-child)[data-node-active='true']::after {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  color: var(--cms-color-text-placeholder);\n  font-size: var(--cms-editor-font-size-heading3) !important;\n  line-height: var(--cms-editor-line-height3) !important;\n  font-weight: var(--cms-editor-heading-font-weight) !important;\n  content: 'Heading 3';\n}\n\n.emoji-shortcut-layout {\n  background-color: var(--cms-color-bg-elevated) !important;\n  width: calc(var(--shortcut-width) * 1px) !important;\n  max-height: calc(var(--shortcut-height) * 1px) !important;\n  box-shadow: var(--cms-box-shadow-secondary) !important;\n  border-radius: calc(var(--cms-border-radius) * 1px) !important;\n  padding: calc(var(--cms-padding-xs) * 1px) !important;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-sizing: border-box !important;\n  border: 1px solid var(--ant-color-border);\n}\n\n.emoji-shortcut-layout .emoji-shortcut-spacing {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  overflow-y: auto;\n  height: 100%;\n  max-height: calc(100% - var(--emoji-search-input-height-container));\n  overflow-x: hidden;\n}\n\n.emoji-shortcut-spacing .emoji-container {\n  padding: calc(var(--cms-padding-xxs) * 1px);\n  border-radius: calc(var(--cms-border-radius-sm) * 1px);\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  transition: background-color 200ms;\n  position: relative;\n  min-width: 36px;\n  max-width: 36px;\n  min-height: 36px;\n  max-height: 36px;\n  cursor: pointer;\n}\n\n.emoji-shortcut-spacing .emoji-container.selected {\n  background-color: var(--cms-control-item-bg-active) !important;\n}\n\n.inserted-date {\n  background-color: var(--toolbar-button-hover);\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 14px;\n  color: var(--date-node-text-color);\n  cursor: pointer;\n}\n.ant-picker-input {\n  display: flex !important; /* Ensure input is visible */\n}\n.ant-picker-input > input {\n  min-width: 82px !important;\n}\n\n/* Editor selected node styles */\n.remirror-editor .ProseMirror-selectednode {\n  background-color: #cce9ff;\n}\n\ntable.remirror-table.remirror-table-with-controllers {\n  margin: 0px 0px calc(var(--cms-padding) * 1px) 0px !important;\n}\n\n.remirror-editor table td > p {\n  margin-bottom: 0px !important;\n}\n\n.document-editor .ProseMirror.remirror-editor.remirror-a11y-dark [data-thread-id] {\n  background: rgba(255, 203, 0, 0.12);\n  border-bottom: 2px solid rgba(255, 203, 0, 0.35);\n  transition:\n    background 0.2s ease,\n    border 0.2s ease;\n}\n\n.document-editor .remirror-editor .callout .callout-icon {\n  --icon-primary-color: #4688e4;\n  --icon-warning-color: #fbc828;\n  --icon-danger-color: #f15b50;\n  --icon-success-color: #b3dfae;\n  max-width: 24px !important;\n  min-width: 24px !important;\n  /* display: flex !important; */\n  flex-direction: row !important;\n  align-items: flex-start !important;\n  justify-content: flex-start !important;\n}\n\n.remirror-editor div.callout {\n  margin-bottom: calc(var(--cms-padding) * 1px) !important;\n}\n\n.remirror-editor div[data-callout-type='danger'] {\n  background: #feecf0 !important;\n  border-left-color: #f14668 !important;\n}\n\n.document-editor .remirror-editor .callout p {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.document-editor .remirror-theme.edit .ProseMirror.remirror-editor.remirror-a11y-dark {\n  padding-bottom: 12rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
